export enum EnumAlertaStatus {
    'Não Lido' = 1,
    Lido = 2
}
